module.exports = __webpack_public_path__ + "subscriptionstaticpage-f4fae5c341788b8b15aa.png";